import React from 'react';

import ParameterComponent from 'sharedreact/components/ParameterComponent';

type Props = {
  className?: string,
  id: string,
  label: string,
  labelClassName?: string,
  labelTooltip?: string,
  value: string | null | (string | JSX.Element)[]
};

class TextInfoField extends React.Component<Props> {
  override render (): React.ReactNode {
    const { className, id, label, labelClassName, value, labelTooltip } =
      this.props;

    return (
      <ParameterComponent
        className={className}
        inputId={id}
        label={label}
        labelClassName={labelClassName}
        labelTooltip={labelTooltip}
      >
        <div className='esko_infotext'>
          {(value == null || value === '') ? '-' : value}
        </div>
      </ParameterComponent>
    );
  }
}

export default TextInfoField;
